export const TRANSACTION_TYPE = {
  'all': "All",
  'invoice': "Invoice",
  'showInvoices': "Invoice",
  'unappliedcash': "Unapplied Cash",
  'showUnappliedCash': "Unapplied Cash",
  'debitnote': "Debit Note",
  'showDebitNotes': "Debit Note",
  'creditnote': "Credit Note",
  'showCreditNotes': "Credit Note",
  'interest': "Interest",
  'showInterest': "Interest",
  'prepayment': "Prepayment",
  'showPrepayment': "Prepayment",
  'receipt': "Receipt",
  'showReceipt': "Receipt",
  'refund': "Refund",
  'showRefund': "Refund",
  'active': "Active",
  'future': "Future",
  'standing': "Standing",
  'quote': "Quote"
}

export const FEATURE_TYPE = {
  "AccountActivity": "Account Activity",
  "ViewTransactions": "View Transactions",
  "PayAccount": "Pay Account",
  "ClickToPay": "Click To Pay",
  "ViewOrders": "View Orders",
  "StoredCards": "Stored Cards",
  "OrderEntry": "Order Entry",
  "PopupComments": "Pop-Up Notice",
  "Salesperson": "Salesperson",
  "Prepayment": "Prepayment",
}
export const GRAPH_DATASET_OPT = {
  barPercentage: 1,
  borderWidth:1,
  fontFamily:'open_sansregular, Arial',
  hoverBackgroundColor:'#0066ff',
  hoverBorderColor:'#0066ff',
  backgroundColor: [ 'rgba(58,118,126, 1)', 'rgba(56,161,172,1)', 'rgba(52,201,209,1)' ],
  borderColor: [ 'rgba(58,118,126, 1)', 'rgba(56,161,172,1)', 'rgba(52,201,209,1)' ]
}

export const GRAPH_OPTION = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
      datalabels: {
          display: false,
          align: 'end',
          anchor: 'end',
          offset: 2,
      }
  },
  tooltips: {
    displayColors: false,
    callbacks: { title: function(tooltipItem, data) { return; } }
  },
  layout: { padding : { left : -25 ,right : -25 , top: 15 }, margin: { top: 15 } },
  hoverMode:'label',
  stacked:false,
  legend: { display: false },
  scales: {
    xAxes:[{
        gridLines: { show:false, drawOnChartArea:false, offsetGridLines: true },
        scaleLabel: { display:true, labelString:"", fontSize:18, fontFamily:'open_sansregular, Arial' },
        // ticks: { minRotation: 90 // angle in degrees }
    }],
    yAxes:[{
      type:'linear',
      display:true,
      position:'left',
      beginAtZero:false,
      integersOnly:true,
      override:null,
      gridLines: { show:true },
      scaleLabel: { display:true, fontSize:18, fontFamily:'open_sansregular, Arial' },
      labels:{ template: "", fontFamily:'open_sansregular, Arial' },
    }]
  }
};

export const N49LOGO = "/content/0/N49logo.svg";

export const FEATURES_ROUTE_MAPPING = {
    AccountActivity: { pathName: 'activity', img: '/content/0/accountactivity.jpg'},
    ViewTransactions: { pathName: "transactions", img: '/content/0/viewtransactions.jpg'},
    ClickToPay: { pathName: "quickpay", img: 'abc'},
    ViewOrders: { pathName: "orders", img: '/content/0/vieworders.jpg'},
    StoredCards: { pathName: "manageCredt", img: '/content/0/managecredit.jpg'},
    PayAccount: { pathName: "payment", img: '/content/0/payaccount.jpg' },
    ContactUs: { pathName: "contactus", img: '/content/0/contactus.jpg' }
  // password   : 'content/0/changepassword.jpg',
};

export const CARD_IMG_LIST = {
    'visa': { name: 'Visa', icon:'/content/0/CC_VI.jpg'},
    'mastercard': { name: 'Mastercard', icon:'/content/0/CC_MC.jpg'},
    'americanexpress': { name: 'American Express', icon:'/content/0/CC_AMEX.jpg'},
    'discover': { name: 'Discover', icon:'/content/0/CC_DS.jpg'},
    //'paypal': { name: 'PayPal', icon:'/content/0/CC_AMEX.jpg'}
};

export const COUNTRY_LIST = [
  {name:"United State",value:'us'},
  {name:"Canada",value:'Canada'},
  {name:"Other",value:'other'},
  {name:"US",value:'us'},
];
export const STATE_LIST = {
  us:[
    {name:"Geogia",value:'ga'},
    {name:"California",value:'ca'},
  ],
  Canada:[
    {name:"Alberta",value:'ab'},
    {name:"BC",value:'bc'},
  ],
};

export const CONNECT_DOWNLOAD_LINK = '/content/0/North49 - Connect.zip';
